import { useEffect, useState } from 'react';
import { getUserInfo } from '../services/application';
import Cache from '../helper/globalCacheHelper';

const CACHE_ACTION_NAME = 'userInfo';
const CACHE_KEY = 'userData';

export const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchUserInfo = async (forceRefresh = false) => {
    if (!forceRefresh && Cache.hasCache(CACHE_ACTION_NAME, CACHE_KEY)) {
      const cachedData = Cache.getCache(CACHE_ACTION_NAME, CACHE_KEY);

      setUserInfo(cachedData);
      return cachedData;
    }

    try {
      setIsLoading(true);
      const response = await getUserInfo();

      Cache.setCache(CACHE_ACTION_NAME, CACHE_KEY, response);

      setUserInfo(response);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      return null;
    }
  };

  const clearUserInfoCache = () => {
    Cache.clearCache(CACHE_ACTION_NAME);
    setUserInfo(null);
  };

  useEffect(() => {
    if (Cache.hasCache(CACHE_ACTION_NAME, CACHE_KEY)) {
      const cachedData = Cache.getCache(CACHE_ACTION_NAME, CACHE_KEY);
      setUserInfo(cachedData);
    } else {
      fetchUserInfo();
    }
  }, []);

  return {
    userInfo,
    isLoading,
    refetch: fetchUserInfo,
    clearCache: clearUserInfoCache,
  };
};
